<template>
  <div class="check-label">
    <el-checkbox v-model="checked" @change="change">
      {{ source[dataLabel] }}
    </el-checkbox>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    source: Object,
    dataLabel: String,
    dataValue: String,
    checkMap: Object,
  },
  data() {
    return {
      checked: false,
    };
  },
  mounted() {
    // 回显勾选状态
    this.checkChange();
  },
  watch: {},
  methods: {
    // 勾选改变
    change(val) {
      this.dispatch(
        "VirtualTransfer",
        "virtual-transfer-check-change",
        this.source[this.dataValue],
        val
      );
    },

    // 选择改变
    checkChange() {
      this.checked =
        this.checkMap[this.source[this.dataValue]] === true ? true : false;
    },
  },
};
</script>

<style scoped>
.check-label ::v-deep .el-checkbox__label {
  font-size: 12px;
  margin-right: 15px;
}
</style>
